export default __webpack_public_path__ + "static/media/graficos-06.9835fe84.png";